import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import {MayanHeroes_Responsive} from "../MayanHeroes/game_responsive";
export class MayanHeroesLink_Responsive extends MayanHeroes_Responsive {

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "MayanHeroesLink");
    }
}